// export default "http://localhost:5000"
//export default "https://comeai.herokuapp.com"
//export default "https://139.59.35.238"
export default "https://www.comeaiapp.com"
